<template>
  <div>
    <v-alert
      v-if="!loading && conversionPackage.type == 'inactive'"
      type="info"
      prominent
      text
      class="py-0  mb-4"
     
      dense
      >
      <v-row align="center">
        <v-col class="grow">Het conversiepakket is nog niet actief voor {{ activeCompData.name }}. Hierdoor is het nog niet mogelijk om <strong>klantinformatie</strong> en <strong>conversie bronnen</strong> te bekijken.</v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            href="https://pillarrr.io/demo/"
            target="_blank"
            >
            Vraag een gratis demo aan
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert
      v-if="!loading && conversionPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
      >
      <v-row align="center">
        <v-col class="grow">De <strong>demo</strong> van het conversiepakket is actief voor {{ activeCompData.name }}. Hierdoor is het nog  mogelijk om <strong>klantinformatie</strong>  en <strong>conversie bronnen</strong> te bekijken.</v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            >
             Nog {{ conversionPackage.days }} <span style="color: #2196f3" v-if="conversionPackage.days == 1" >dag</span><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-container v-if="!loading && companies.length > 1" grid-list-md class="pa-0 pt-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadActiveCompData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="loading" class="blackbox-loader"></div>

    <div v-if="!loading && conversionPackage.type != 'inactive'" class="special-content-box mt-4">
      <tabs :options="{ useUrlFragment: false }">
        <tab name="Algemeen" v-if="userRole == 'superadmin' || userRole == 'admin'" class="first">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
            <div class="tab-item">
              <div class="tab-item-field">
                <v-container grid-list-md class="pa-0" fluid>
                  <v-layout row wrap>
                    <v-flex md6 xs12>
                      <h1 class="tab-title">Algemene instellingen</h1>
                    </v-flex>
                    <v-flex md6 xs12>
                      <div style="display: inline-block; float: right;">
                        <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="changed" :loading="updateWidgetSettingsBusy" :disabled="!changed" :depressed="!changed" @click="updateWidgetSettings()">Wijzigingen opslaan<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
                      </div>
                    </v-flex>

                    <v-flex md6 xs12>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="conversionStartDialog"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            outlined
                            style="max-width: 450px"
                            :color="companyPrimaryColor"
                            v-on="on"
                            dense
                            background-color="background"
                            v-model="conversionStartDate.readable"
                            label="Startdatum"
                            prepend-inner-icon="event"
                            readonly
                            hint="Selecteer de datum waarop het bedrijf gestart is met Pillarrr conversies."
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="conversionStartDateRaw"
                          :color="companyPrimaryColor"
                          no-title
                          @input="conversionStartDialog = false"
                        ></v-date-picker>
                      </v-menu>

                      <v-text-field
                        class="pt-4"
                        style="max-width: 450px"
                        label="Succes url"
                        v-model="activeCompData.conversion.salonhubSettings.succesUrl"
                        prepend-inner-icon="web"
                        :color="companyPrimaryColor"
                        background-color="background"
                        hint="Bezoeker wordt naar deze pagina doorverwezen naar succesvol afronden van de widget."
                        persistent-hint
                        required
                        outlined
                      ></v-text-field>

                      <v-text-field
                        v-if="userRole == 'superadmin'"
                        class="pt-4"
                        style="max-width: 450px"
                        label="Adwords dagbudget"
                        prefix="€"
                        v-model.number="activeCompData.conversion.adwordsBudget"
                        prepend-inner-icon="credit_card"
                        :color="companyPrimaryColor"
                        background-color="background"
                        hint="Alleen zichtbaar voor superadmins"
                        persistent-hint
                        required
                        outlined
                      ></v-text-field>

                      <v-switch
                        class="mt-3 pa-0"
                        label="Vraag klanten om feedback bij afsluiten zonder succes"
                        v-model="activeCompData.conversion.feedBackOnClose"
                        persistent-hint
                        hint="Kom meer te weten over de reden van afhaken."
                        :color="companyPrimaryColor"
                      ></v-switch>

                      <v-switch
                        class="mt-3 pa-0"
                        label="Vraag klanten in widget of ze gebeld willen worden"
                        v-model="activeCompData.conversion.showCallback"
                        persistent-hint
                        hint="Vraag wordt getoond bij 'geen beschikbaarheid' of 'afsluiten zonder conversie'. Dit wordt weergegeven in de statistieken."
                        :color="companyPrimaryColor"
                      ></v-switch>
                    </v-flex>
                    
                    <v-flex md6 xs12>
                      <p>Extra  voorwaarden om akkoord te gaan in de afspraakwidget. <br>Als er geen URL ingevoerd is wordt er niet gevraagd om hier akkoord mee te gaan.</p>
                      <v-text-field
                        class="pt-0"
                        style="max-width: 450px"
                        label="Extra algemene voorwaarden URL"
                        v-model="activeCompData.conversion.termsUrl"
                        prepend-inner-icon="mdi-web-check"
                        :color="companyPrimaryColor"
                        background-color="background"
                        hint="Bezoeker moet akkoord gaan met de inhoud van deze URL om door te gaan."
                        persistent-hint
                        required
                        outlined
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>

              </div>
            </div>

            <div class="tab-item">
              <h2>Conversie bronnen</h2>

              <div class="default-source-tags">
                <div style="padding: 5px 0;">
                  <p style="font-weight: bold; font-size: 16px;">Algemene tags</p>
                  <p><i>Voeg nieuwe tags toe om te meten waar conversies vandaan komen.</i></p>
                  </div>

                <div style="display: inline-block;" v-for="(tag ,index) in generalTags" :key="index">
                  <v-btn class="ma-1" small :color="tag.color" :style="{color: tag.textColor}" style="text-transform: none;">{{tag.name}}<span class="tag-query" :style="{color: tag.textColor}">[?src={{ tag.query }}]</span></v-btn>
                  <div v-if="tag.copy == false" class="copy-tag-url" @click="copyTextToClipboard( activeCompData.url + '/?src=' + tag.query, index, 'tag' )"><v-icon small color="#333">filter_none</v-icon> Kopi&euml;er url</div>
                  <div v-else class="copy-tag-url copied" >Gekopi&euml;erd</div>
                </div>
              </div>

              <div class="conversion-source-tags">
                <v-container grid-list-md class="pa-0" fluid>
                  <v-layout row wrap>
                    <v-flex xs8>
                      <div style="padding: 5px 10px;">
                        <p style="font-weight: bold; font-size: 16px;">Eigen tags</p>
                        <p><i>Voeg nieuwe tags toe om per campagne exact de conversies te meten.</i></p>
                      </div>
                    </v-flex>
                    <v-flex xs4>
                      <v-btn small style="float: right;" v-if="activeCompData.conversion.sources.length > 0" :color="companyPrimaryColor" fab dark @click="addNewConversionSource()">
                        <v-icon small>add</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
                <div style="display: inline-block;" v-for="(source, index) in activeCompData.conversion.sources" :key="index">
                  <v-btn class="ma-1" small :color="source.bgColor.hex"  :style="{color: source.textColor.hex}" style="text-transform: none;">
                    {{ source.name }} <span class="tag-query" :style="{color: source.textColor.hex}">[?src={{ source.query }}]</span> <v-icon @click.native="editConversionSource(index)"  :color="source.textColor.hex" dark small right>edit</v-icon> <v-icon @click="deleteConversionSourceDialog(index)" :color="source.textColor.hex" dark small right>delete</v-icon>
                  </v-btn>
                  <div v-if="source.copy == false" class="copy-tag-url" @click="copyTextToClipboard( activeCompData.url + '/?src=' + source.query, index, 'source' )"><v-icon small color="#333">filter_none</v-icon> Kopi&euml;er url</div>
                  <div v-else class="copy-tag-url copied" >Gekopi&euml;erd</div>
                </div>
                <div class="text-center" v-if="activeCompData.conversion.sources.length == 0">
                  <v-btn :color="companyPrimaryColor" fab dark @click="addNewConversionSource()">
                    <v-icon>add</v-icon>
                  </v-btn>
                  <p style="text-align: center; padding: 10px 0;">Er zijn nog geen eigen tags gemaakt. Voeg deze toe.</p>
                </div>
              </div>
            </div>

            <div v-if="activeCompData.apiItems.salonhub">
              <h2 style="margin: 0 0 20px 0;">Instellingen Salonhub</h2>

              <v-container grid-list-md class="pa-0" fluid style="margin: 0 0 20px 0;">
                <v-layout row wrap>
                  <v-flex d-flex xs6 md4>
                    <div :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover}"  style="padding: 18px;">
                      <h3 style="margin: 0 0 10px 0;"><b>Pillarrr bevestigingsmail</b></h3>
                      <p>De Pillarrr bevestigingsmail is in <b>verschillende talen</b> in te stellen en tekstueel volledig zelf in te vullen. Voeg naar eigen wens per taal een onderwerp, <b>teksten</b> en <b>links</b> toe.</p>
                      <v-switch
                        class="mt-3 pa-0"
                        label="Pillarrr bevestigingsmail gebruiken"
                        v-model="activeCompData.conversion.salonhubSettings.enableConfirmationEmail"
                        :color="companyPrimaryColor"
                      ></v-switch>
                      <v-alert
                        v-if="activeCompData.conversion.salonhubSettings.enableConfirmationEmail"
                        :value="true"
                        color="warning"
                        icon="warning"
                        outlined
                      >
                        Let op! Maak je gebruik van de Pillarrr bevestigingsmail? Zorg dat de bevestigingsmail in Salonhub uitzet om dubbele emails te voorkomen.
                      </v-alert>
                    </div>
                  </v-flex>
                  <v-flex d-flex xs6 md4>
                      <div :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover}" style="padding: 18px;">
                      <h3 style="margin: 0 0 10px 0;"><b>Bevestigingsmail voor nieuwe klanten</b></h3>
                      <p>Soms wil je <b>nieuwe klanten</b> voorzien van <b>andere informatie</b> of zelfs vragen eerst een <b>aanbetaling</b> te doen. Dit kan met de Pillarrr bevestigingsmail voor nieuwe klanten.</p>
                      <v-tooltip bottom v-if="!activeCompData.conversion.salonhubSettings.enableConfirmationEmail">
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-switch
                              class="mt-3 pa-0"
                              disabled
                              value="false"
                              :color="companyPrimaryColor"
                              hide-details
                              >
                              <template v-slot:label>
                                <div> Pillarrr bevestigingsmail gebruiken<v-icon style="padding: 0 0 4px 4px; cursor: pointer;" v-if="!activeCompData.conversion.salonhubSettings.enableConfirmationEmail" small color="#333" >help</v-icon></div>
                              </template>
                            </v-switch>
                          </div> 
                        </template>
                        <span style="color: #fff">Alleen beschikbaar als Pillarrr bevestigingsmail actief is.</span>
                      </v-tooltip>

                      <v-switch
                        v-if="activeCompData.conversion.salonhubSettings.enableConfirmationEmail"
                        class="mt-3 pa-0"
                        :disabled="!activeCompData.conversion.salonhubSettings.enableConfirmationEmail"
                        label="Pillarrr bevestigingsmail gebruiken"
                        v-model="activeCompData.conversion.salonhubSettings.separateConfirmationEmailNewClient"
                        :color="companyPrimaryColor"
                        hide-details
                      ></v-switch>  
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>      

              <v-container grid-list-md class="pa-3" fluid :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover}">
                <div style="padding: 10px 0;">
                  <p style="font-weight: bold; font-size: 16px;">Widget url</p>
                  <p><i>Gebruik in campagnes om te linken in naar de website met extra conversie informatie of alleen om de widget te openen</i></p>
                </div>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-select
                      outlined
                      :color="companyPrimaryColor"
                      :item-color="companyPrimaryColor"
                      class="my-2"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      :items="allConversionItems"
                      prepend-inner-icon="forward"
                      item-text="name"
                      item-value="query"
                      v-model="campagnUrl.source"
                      label="Selecteer bron"
                      hide-details
                      clearable
                      >
                    </v-select>
                    
                    <v-switch
                      class="mt-3 pa-0"
                      label="Widget gelijk openen"
                      v-model="campagnUrl.openWidget"
                      :color="companyPrimaryColor"
                    ></v-switch>
                    <v-container v-if="campagnUrl.openWidget" grid-list-md class="pa-0" fluid>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-select
                            outlined
                            :color="companyPrimaryColor"
                            :item-color="companyPrimaryColor"
                            class="my-2"
                            :background-color="$vuetify.theme.themes[theme].menu"
                            :items="languages"
                            prepend-inner-icon="flag"
                            item-text="name"
                            item-value="code"
                            v-model="campagnUrl.lang"
                            label="Selecteer taal"
                            hide-details
                            >
                          </v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            outlined
                            :color="companyPrimaryColor"
                            :item-color="companyPrimaryColor"
                            class="my-2"
                            :background-color="$vuetify.theme.themes[theme].menu"
                            :items="widgetInfoPostion"
                            prepend-inner-icon="person"
                            item-text="name"
                            item-value="id"
                            v-model="campagnUrl.ci"
                            label="Invoer persoongegevens"
                            hide-details
                            >
                          </v-select>
                        </v-flex>
                        
                        <v-flex xs6>
                          <v-text-field
                            outlined
                            :color="companyPrimaryColor"
                            class="my-2"
                            :background-color="$vuetify.theme.themes[theme].menu"
                            v-model="campagnUrl.name"
                            prepend-inner-icon="person"
                            label="Naam"
                            hide-details
                          ></v-text-field>
                          <p style="font-size: 12px; padding: 2px "><i>Bijvoorbeeld Mailchimp variable: *|FNAME|*</i></p>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            outlined
                            :color="companyPrimaryColor"
                            class="my-2"
                            :background-color="$vuetify.theme.themes[theme].menu"
                            prepend-inner-icon="email"
                            v-model="campagnUrl.email"
                            label="E-mailadres"
                            hide-details
                          ></v-text-field>
                          <p style="font-size: 12px; padding: 2px "><i>Bijvoorbeeld Mailchimp variable: *|EMAIL|*</i></p>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            outlined
                            :color="companyPrimaryColor"
                            class="my-2"
                            :background-color="$vuetify.theme.themes[theme].menu"
                            prepend-inner-icon="phone"
                            v-model="campagnUrl.phone"
                            label="Telefoonnummer"
                            hide-details
                          ></v-text-field>
                          <p style="font-size: 12px; padding: 2px "><i>Bijvoorbeeld Mailchimp variable: *|PHONE|*</i></p>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            outlined
                            :color="companyPrimaryColor"
                            :item-color="companyPrimaryColor"
                            v-if="branches.length > 1"
                            class="my-2"
                            :background-color="$vuetify.theme.themes[theme].menu"
                            :items="branches"
                            prepend-inner-icon="location_on"
                            item-text="branchName"
                            item-value="branchNameSalonhub"
                            v-model="campagnUrl.branch"
                            label="Selecteer vestiging"
                            hide-details
                            >
                          </v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            outlined
                            :color="companyPrimaryColor"
                            :item-color="companyPrimaryColor"
                            class="my-2"
                            :background-color="$vuetify.theme.themes[theme].menu"
                            :items="showPricesValues"
                            prepend-inner-icon="euro"
                            item-text="name"
                            item-value="id"
                            v-model="campagnUrl.showPrices"
                            label="Toon prijzen aan bezoekers"
                            hide-details
                            >
                          </v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            outlined
                            :color="companyPrimaryColor"
                            class="my-2"
                            :background-color="$vuetify.theme.themes[theme].menu"
                            prepend-inner-icon="looks_4"
                            v-model="campagnUrl.treatment"
                            label="Behandeling ID"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>

                  </v-flex>
                </v-layout>
                <div style="display: block; padding: 5px 5px 15px 5px;">
                  <div style="display: inline-block; font-style: italic; padding: 5px 10px; color: #fff; background-color: #333;" v-if="websiteUrl.enable">{{ websiteUrl.url}}</div>
                  <div style="font-style: italic;" v-else>Selecteer minimaal de <b>'Bron'</b> of <b>'Widget gelijk openen'</b> om url te genereren.</div>
                </div>
                
                <v-btn :dark="websiteUrl.enable" :depressed="!websiteUrl.enable" :disabled="!websiteUrl.enable" :color="companyPrimaryColor" @click="copyTextToClipboard(websiteUrl.url, null, 'campagne')"><v-icon left small color="#fff">filter_none</v-icon> Kopi&euml;er url</v-btn>
                <div style="display: inline-block" v-if="campagnUrl.copy" class="copy-tag-url copied" >Gekopi&euml;erd</div>
                
              </v-container>

            </div>
          </div>
        </tab>

        <tab name="Bevestigingsmail" v-if="(userRole == 'superadmin' || userRole == 'admin') && activeCompDataOriginal.conversion.salonhubSettings.enableConfirmationEmail">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
              <div>
              <v-container grid-list-md class="pa-0" fluid>
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <h1 class="tab-title">Bevestigingsmail</h1>
                  </v-flex>
                  <v-flex md6 xs12>
                    <div style="display: inline-block; float: right;">
                      <v-btn rounded :dark="confirmChanged" :disabled="!confirmChanged" :depressed="!confirmChanged"  :color="companySecondaryColor"  class="modal-button-next" @click="updateCovenversionConfirmEmail()">Wijzigingen opslaan<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
                    </div>

                    <div style="display: inline-block; float: right; padding: 0 0 5px 0;">

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" class="mx-2" outlined dark :color="companySecondaryColor" @click="defaultConfirmEmail()">Gebruik standaard tekst</v-btn>
                        </template>
                        <span style="color: #fff">Standaard e-mailtekst en onderwerp voor bevestigingsmail instellen in het 
                          <span v-for="(language, index) in languages" :key="index">
                            <span style="color: #fff" v-if="selectedLanguage == language.code">{{ language.name }}</span>
                          </span>.
                        </span>
                      </v-tooltip>
                      
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

              <div  class="select-language-wrapper clear">
                <div class="select-language-flag">
                  <div v-if="selectedLanguage == 'en'" class="language-flag uk"></div>
                  <div v-if="selectedLanguage == 'nl'" class="language-flag nl"></div>
                </div>
                <div class="select-language-input">
                  <v-select
                    outlined
                    background-color="background"
                    v-model="selectedLanguage"
                    :items="languages"
                    label="Selecteer taal"
                    item-text="name"
                    item-value="code"
                  ></v-select>
                </div>
              </div>

              <div style="padding: 10px 0 0 0;">De onderstaande variabelen zijn te gebruiken in de e-mail:</div>

              <div style="display: inline-block;" v-for="(variable, index) in emailVariables" :key="index">
                <v-btn small color="#333" class="ma-1" style="color: #fff; text-transform: none;">{{ variable.name }}</v-btn>
                <div v-if="variable.copy == false" class="copy-tag-url" @click="copyVariableToClipboard( variable.name, index, )"><v-icon small color="#333">filter_none</v-icon> Kopi&euml;er</div>
                <div v-else class="copy-tag-url copied" >Gekopi&euml;erd</div>
              </div>

              <div class="email-preview-wrapper">
                <div class="tab-item-field" style="padding: 20px 0 0 0;">
                  <v-container grid-list-md class="pa-0" fluid>
                    <v-layout row wrap>
                      <v-flex  xs12>
                        <v-text-field
                          label="Onderwerp"
                          v-model="activeCompData.conversion.salonhubSettings.confirmationEmail.emailSubject[selectedLanguage]"
                          counter="65"
                          maxlength="65"
                          outlined
                          background-color="background"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>

                <div class="email-preview">
                  <div class="email-wrapper">
                    <div class="email-logo">
                      <img :src="activeCompData.logoUrl">
                    </div>
                    <ckeditor type="classic" v-model="activeCompData.conversion.salonhubSettings.confirmationEmail.emailContent[selectedLanguage]" :upload-adapter="UploadAdapter" :config="editorConfig"></ckeditor>   
                  </div>

                  <div class="social-preview-wrapper">
                    <p>
                      <a v-if="activeCompData.social.facebook == true" :href="activeCompData.social.facebookUrl" target="_blank" class="social-icon-preview facebook"> </a>
                      <a v-if="activeCompData.social.instagram == true" :href="activeCompData.social.instagramUrl" target="_blank" class="social-icon-preview instagram"> </a>
                      <a v-if="activeCompData.social.pinterest == true" :href="activeCompData.social.pinterestUrl" target="_blank" class="social-icon-preview pinterest"> </a>
                      <a v-if="activeCompData.social.twitter == true" :href="activeCompData.social.twitterUrl" target="_blank" class="social-icon-preview twitter"> </a>
                      <a v-if="activeCompData.social.googleplus == true" :href="activeCompData.social.googleplusUrl" target="_blank" class="social-icon-preview googleplus"> </a>
                    </p>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </tab>

        <tab name="Bevestigingsmail nieuwe klant" v-if="(userRole == 'superadmin' || userRole == 'admin') && activeCompDataOriginal.conversion.salonhubSettings.separateConfirmationEmailNewClient">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
              <div>
              <v-container grid-list-md class="pa-0" fluid>
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <h1 class="tab-title">Bevestigingsmail voor nieuwe klanten</h1>
                  </v-flex>
                  <v-flex md6 xs12>
                    <div style="display: inline-block; float: right;">
                      <v-btn rounded :dark="confirmNewClientChanged" :disabled="!confirmNewClientChanged" :depressed="!confirmNewClientChanged"  :color="companySecondaryColor"  class="modal-button-next" @click="updateCovenversionConfirmEmailNewClient()">Wijzigingen opslaan<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
                    </div>
                    <div style="display: inline-block; float: right; padding: 0 0 5px 0;">

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn class="mx-2" v-on="on" outlined  dark :color="companySecondaryColor" @click="defaultConfirmEmailNewClient()">Gebruik standaard tekst</v-btn>
                        </template>
                        <span style="color: #fff">Standaard e-mailtekst en onderwerp voor bevestigingsmail instellen in het 
                          <span v-for="(language, index) in languages" :key="index">
                            <span style="color: #fff" v-if="selectedLanguage == language.code">{{ language.name }}</span>
                          </span>.
                        </span>
                      </v-tooltip>
                      
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

              <div  class="select-language-wrapper clear">
                <div class="select-language-flag">
                  <div v-if="selectedLanguage == 'en'" class="language-flag uk"></div>
                  <div v-if="selectedLanguage == 'nl'" class="language-flag nl"></div>
                </div>
                <div class="select-language-input">
                  <v-select
                    v-model="selectedLanguage"
                    :items="languages"
                    outlined
                    background-color="background"
                    label="Selecteer taal"
                    item-text="name"
                    item-value="code"
                  ></v-select>
                </div>
              </div>

              <div style="padding: 10px 0 0 0;">De onderstaande variabelen zijn te gebruiken in de e-mail:</div>

              <div style="display: inline-block;" v-for="(variable, index) in emailVariables" :key="index">
                <v-btn small :color="$vuetify.theme.themes[theme].text" class="ma-1" :style="{color: $vuetify.theme.themes[theme].menu}" style="text-transform: none;">{{ variable.name }}</v-btn>
                <div v-if="variable.copy == false" class="copy-tag-url" @click="copyVariableToClipboard( variable.name, index, )"><v-icon small color="#333">filter_none</v-icon> Kopi&euml;er</div>
                <div v-else class="copy-tag-url copied" >Gekopi&euml;erd</div>
              </div>

              <div class="email-preview-wrapper">
                <div class="tab-item-field" style="padding: 20px 0 0 0;">
                  <v-container grid-list-md class="pa-0" fluid>
                    <v-layout row wrap>
                      <v-flex  xs12>
                        <v-text-field
                          label="Onderwerp"
                          v-model="activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailSubject[selectedLanguage]"
                          background-color="background"
                          counter="65"
                          maxlength="65"
                          outlined
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>

                <div class="email-preview" :style="{backgroundColor: $vuetify.theme.themes[theme].background}">
                  <div class="email-wrapper" :style="{backgroundColor: $vuetify.theme.themes[theme].menu, borderColor: $vuetify.theme.themes[theme].menuborder}">
                    <div class="email-logo">
                      <img :src="activeCompData.logoUrl">
                    </div>
                    <ckeditor type="classic" v-model="activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailContent[selectedLanguage]" :upload-adapter="UploadAdapter" :config="editorConfig"></ckeditor>   
                  </div>

                  <div class="social-preview-wrapper">
                    <p>
                      <a v-if="activeCompData.social.facebook == true" :href="activeCompData.social.facebookUrl" target="_blank" class="social-icon-preview facebook"> </a>
                      <a v-if="activeCompData.social.instagram == true" :href="activeCompData.social.instagramUrl" target="_blank" class="social-icon-preview instagram"> </a>
                      <a v-if="activeCompData.social.pinterest == true" :href="activeCompData.social.pinterestUrl" target="_blank" class="social-icon-preview pinterest"> </a>
                      <a v-if="activeCompData.social.twitter == true" :href="activeCompData.social.twitterUrl" target="_blank" class="social-icon-preview twitter"> </a>
                      <a v-if="activeCompData.social.googleplus == true" :href="activeCompData.social.googleplusUrl" target="_blank" class="social-icon-preview googleplus"> </a>
                    </p>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </tab>

        <tab name="Callcenter" v-if="userRole == 'superadmin'">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <h1 class="tab-title">Callcenter instellingen</h1>
                </v-flex>
                <v-flex md6 xs12>
                  <div style="display: inline-block; float: right;">
                    <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="callChanged" :loading="updateCallcenterBusy" :disabled="!callChanged" :depressed="!callChanged" @click="updateCallcenterSettings()">Wijzigingen opslaan<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-switch
                  :color="companyPrimaryColor.hex"
                  label="Callmodule gebruiken"
                  v-model="activeCompData.conversion.callcenter.callModule"
                  hide-details
                ></v-switch>
                <v-switch
                  :color="companyPrimaryColor.hex"
                  label="Hogans als eerste bellen"
                  v-model="activeCompData.conversion.callcenter.hogansFirst"
                  hide-details
                ></v-switch>
                  <v-text-field
                    class="pt-4"
                    label="Twilio nummer"
                    v-model="activeCompData.conversion.callcenter.twilioNumber"
                    background-color="background"
                    prepend-inner-icon="phone"
                    :color="companyPrimaryColor"
                    hide-details
                    required
                    outlined
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </tab>

        <tab name="SMS-marketing">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
            

            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <h1 class="tab-title">SMS-marketing</h1>
                  <p>Klanten ontvangen maximaal 1x per dag een sms bij het sluiten van de widget zonder afspraak te maken.</p>
                </v-flex>
                <v-flex md6 xs12>
                  <div style="display: inline-block; float: right;">
                    <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="smsSettingsChanged" :loading="updateSmsSettingsBusy" :disabled="!smsSettingsChanged" :depressed="!smsSettingsChanged" @click="updateSmsSettings()">Wijzigingen opslaan<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-alert
                    class="ma-0 pa-1"
                    v-if="smsSettingsFeedback"
                    :value="true"
                    type="warning"
                  >
                  {{ smsSettingsFeedback }} 
                  </v-alert>

                  <v-switch
                    class="mt-3 pa-0"
                    label="Sms versturen na afhaken in de widget."
                    v-model="activeCompData.conversion.smsSettings.smsOnClose"
                    :color="companyPrimaryColor"
                  ></v-switch>
                </v-flex>
              </v-layout>

                <v-layout row wrap>
                  <v-flex xs4>
                    <v-text-field
                      class="py-4"
                      label="Naam afzender"
                      v-model="activeCompData.conversion.smsSettings.senderID"
                      background-color="background"
                      :color="companyPrimaryColor"
                      counter
                      :rules="[rules.senderID, rules.counter]"
                      maxlength="11"
                      persistent-hint
                      hint="Naam mag geen spaties of speciale letters bevatten."
                      required
                      outlined
                    ></v-text-field>

                    <div  class="select-language-wrapper clear">
                      <div class="select-language-flag">
                        <div v-if="selectedLanguage == 'en'" class="language-flag uk"></div>
                        <div v-if="selectedLanguage == 'nl'" class="language-flag nl"></div>
                      </div>
                      <div class="select-language-input">
                        <v-select
                          outlined
                          background-color="background"
                          v-model="selectedLanguage"
                          :items="languages"
                          label="Selecteer taal"
                          item-text="name"
                          item-value="code"
                        ></v-select>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="pt-4">
                  <v-flex md4 xs12>
                    
                    
                    <h3><strong>Bericht dat éénmalig verzonden wordt na afhaken in de widget</strong></h3>
                    <v-textarea
                      class="pt-2"
                      v-model="activeCompData.conversion.smsSettings.callUsText[selectedLanguage]"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].background"
                      required
                      rows="10"
                      no-resize
                      outlined
                      counter
                      maxlength="152"
                    ></v-textarea>
                  </v-flex>
                  <v-flex md4 xs12>
                  </v-flex>
                  <v-flex md4 xs12>
                  </v-flex>
                </v-layout>

            </v-container>
          </div>
        </tab>

         <tab name="Blacklist terugbellen">
          <div v-if="loading == false" class="tab-inner-wrapper">
            
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap class="pa-4">
                <v-flex md6 xs12>
                  <h1 class="tab-title">Blacklist terugbellen</h1>
                  <p>Telefoonnummers die niet meer gebeld willen worden n.a.v. de widget.</p>
                </v-flex>
                <v-flex md6 xs12 class="pt-4 text-right">
                  <v-btn fab dark :color="companyPrimaryColor"  @click="newBlacklist.dialog = true">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-layout row wrap v-if="blacklisted.length > 0">
                <v-flex xs12>
                  <v-data-table
                    :headers="headersBlacklist"
                    :items="blacklisted"
                    :itemsPerPage.sync="userPages"
                    hide-default-footer
                    class="users-table"
                    >
                    <template v-slot:item="{item }">
                      <tr>
                        <td>{{ item.phone }} </td>
                        <td>{{ item.comment }} </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs12>
                  <v-card flat outlined class="text-center pa-5">
                    <strong>Er zijn geen telefoonummers toegevoegd.</strong>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </tab>
        
      </tabs>
    </div>

    <div v-if="!loading && conversionPackage.type == 'inactive'" class="special-content-box mt-4">
      <div style="text-align: center; padding: 150px 0;">
        <v-icon large :color="companyPrimaryColor">warning</v-icon>
        <p>Instellingen kunnen alleen gedaan worden als het conversie pakket actief is.</p>
      </div>
    </div>
     
    <!-- / New Conversion Source Dialog \-->
    <v-dialog v-model="newConversionSource.dialog" max-width="600">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text">Nieuwe tag toevoegen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="newConversionSource.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert
          class="ma-0 pa-1"
          v-if="newConversionSource.feedback"
          :value="true"
          type="warning"
        >
        {{ newConversionSource.feedback }} 
        </v-alert>

        <v-divider></v-divider>
          
        <v-card-text>
          <v-text-field
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Naam"
            v-model="newConversionSource.name"
            required
            hide-details
          ></v-text-field>

          <v-text-field
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Query"
            v-model="newConversionSource.query"
            hint="Gebruik deze query text in de url om de conversie via de widget te meten."
            persistent-hint
            required
          ></v-text-field>

          <div class="color-box-wrapper clear" style="padding: 5px 0 15px 0">
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="color-boxes-icon">
                    <v-icon>palette</v-icon>
                  </div>
                  <div class="color-boxes clear">
                    <p class="ma-0"> Selecteer achtergrond kleur</p>
                    <div class="color-box" v-bind:style="{ backgroundColor: newConversionSource.bgColor.hex }" @click="newConversionSource.bgColorDialog = true"></div>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="color-boxes-icon">
                    <v-icon>palette</v-icon>
                  </div>
                  <div class="color-boxes clear">
                    <p class="ma-0">Selecteer tekst kleur</p>
                    <div class="color-box" v-bind:style="{ backgroundColor: newConversionSource.textColor.hex }" @click="newConversionSource.textColorDialog = true"></div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="newConversionSource.dialog = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="addConversionSourceTag()"
                  >
                  Tag toevoegen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ New Conversion Source Dialog / -->

    <!-- / New Conversion Source Dialog \-->
    <v-dialog v-model="selectedConversionSource.dialog" max-width="600">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text">Tag wijzigen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="selectedConversionSource.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-alert
          class="ma-0 pa-1"
          v-if="selectedConversionSource.feedback"
          :value="true"
          type="warning"
          >
        {{ selectedConversionSource.feedback }} 
        </v-alert>

        <v-divider></v-divider>
          
        <v-card-text>
          <v-text-field
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Naam"
            v-model="selectedConversionSource.name"
            required
            hide-details
          ></v-text-field>

          <v-text-field
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Query"
            v-model="selectedConversionSource.query"
            hint="Gebruik deze query text in de url om de conversie via de widget te meten."
            persistent-hint
            required
          ></v-text-field>

          <div class="color-box-wrapper clear" style="padding: 5px 0 15px 0">
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="color-boxes-icon">
                    <v-icon>palette</v-icon>
                  </div>
                  <div class="color-boxes clear">
                    <p class="ma-0">Selecteer achtergrond kleur</p>
                    <div class="color-box" v-bind:style="{ backgroundColor: selectedConversionSource.bgColor.hex }" @click="selectedConversionSource.bgColorDialog = true"></div>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="color-boxes-icon">
                    <v-icon>palette</v-icon>
                  </div>
                  <div class="color-boxes clear">
                    <p class="ma-0">Selecteer tekst kleur</p>
                    <div class="color-box" v-bind:style="{ backgroundColor: selectedConversionSource.textColor.hex }" @click="selectedConversionSource.textColorDialog = true"></div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="selectedConversionSource.dialog = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="updateConversionSourceTag()"
                  >
                  Wijzingen opslaan
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ New Conversion Source Dialog / -->

    <!-- / New Blacklist Dialog \-->
    <v-dialog v-model="newBlacklist.dialog" max-width="600">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text">Telefoonnummer toevoegen aan Blacklist</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="newBlacklist.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-alert
          class="ma-0 pa-1"
          v-if="newBlacklist.feedback"
          :value="true"
          type="warning"
          >
        {{ newBlacklist.feedback }} 
        </v-alert>

        <v-divider></v-divider>
          
        <v-card-text>
          <v-text-field
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Telefoonummer"
            v-model="newBlacklist.phone"
            required
            hide-details
          ></v-text-field>

          <v-textarea
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Opmerkingen"
            row="6"
            v-model="newBlacklist.comment"
            required
            hide-details
          ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="newBlacklist.dialog = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="addPhoneToBlacklist()"
                  >
                  Opslaan
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ New Blacklist Dialog / -->

    <!-- / Delete source dialog \ -->
    <v-dialog v-model="deleteSelectedSource.dialog" width="350">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text">Tag verwijderen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="deleteSelectedSource.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <span style=" display: block; text-align: center!important;">De tag zal worden verwijderd. Dit kan niet ongedaan worden gemaakt.</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="deleteSelectedSource.dialog = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="deleteConversionSource()"
                  >
                  Verwijderen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ Delete source dialog / -->

    <v-dialog width="225px" v-model="newConversionSource.bgColorDialog">
      <chrome-picker v-model="newConversionSource.bgColor"></chrome-picker>
    </v-dialog>
    <v-dialog width="225px" v-model="newConversionSource.textColorDialog">
      <chrome-picker v-model="newConversionSource.textColor"></chrome-picker>
    </v-dialog>
    <v-dialog width="225px" v-model="selectedConversionSource.bgColorDialog">
      <chrome-picker v-model="selectedConversionSource.bgColor"></chrome-picker>
    </v-dialog>
    <v-dialog width="225px" v-model="selectedConversionSource.textColorDialog">
      <chrome-picker v-model="selectedConversionSource.textColor"></chrome-picker>
    </v-dialog>

  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { bus } from "../main";
import db from "../firebase/init";
import platform from 'platform'; 
import slugify from "slugify";
import { Chrome } from "vue-color";

export default {
  name: "WidgetSettings",

  components: {
    "chrome-picker": Chrome,
  },

  data: () => ({
    loading: true,
    // editor: ClassicEditor,
    editorConfig: {
      // plugins: [Alignment ], 
      toolbar: ['heading', 'bold', 'italic', 'bulletedList', 'numberedList',  '|', 'link' , 'ImageUpload',  '|', 'insertTable', "|", 'undo', "redo", ], 
      table: {
        contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
      },
    },
    headersBlacklist: [
      {
        text: "Telefoonnummer",
        value: "phone",
      },
      {
        text: "Opmerking",
        value: "comment",
      }
    ],
    blacklisted: new Array(),
    newBlacklist: {
      dialog: false,
      phone: null,
      comment: null
    },
    userPages: -1,
    feedback: null,
    activeCompData: {
      apiItems: {
        drupal: false,
        salonhub: false
      },
      social: {
        facebook: false,
        facebookUrl: null
      }
    },
    widgetUrl: {
      lang: 'nl',
      info: 'front',
      copy: false
    },
    showPricesValues: [
      {
        id: 'yes',
        name: 'Prijzen tonen',
      },
      {
        id: 'no',
        name: 'Prijzen verbergen',
      }
    ],
    emailVariables: [
      {
        id: 'firstName',
        name: '[Voornaam]',
        copy: false
      },
      {
        id: 'date',
        name: '[Afspraakdatum]',
        copy: false
      },
      {
        id: 'time',
        name: '[Afspraaktijdstip]',
        copy: false
      },
      {
        id: 'branch',
        name: '[Salon]',
        copy: false
      },
      {
        id: 'price',
        name: '[Prijs]',
        copy: false
      },

    ],
    searchCompanies: "",
    updateCallcenterBusy: false,
    updateSmsSettingsBusy: false,
    updateWidgetSettingsBusy: false,
    campagnUrl: {
      source: null,
      copy: false,
      openWidget: false,
      name: null,
      email: null,
      phone: null,
      treatment: null,
      branch: null,
      lang: 'nl',
      ci: 'front',
      showPrices: "no"
    },
    generalTags: [
      {
        name: 'Adwords',
        query: 'adw',
        copy: false,
        color: '#1a73e8',
        textColor: '#fff'
      },
      {
        name: 'Mailchimp',
        query: 'mc',
        copy: false,
        color: '#ffe01b',
        textColor: '#333'
      }
    ],

    widgetInfoPostion: [
      {
        name: "Vooraan",
        id: "front"
      },
      {
        name: "Achteraan",
        id: "back"
      }
    ],
    languages: [
      {
        name: "Nederlands",
        code: "nl"
      },
      {
        name: "Engels",
        code: "en"
      }
    ],
    newConversionSource: {
      dialog: false,
      feedback: null,
      name: "",
      query: "",
      textColor: {
        hex: '#ffffff'
      },
      bgColor: {
        hex: "#333333"
      },
      textColorDialog: false,
      bgColorDialog: false,
    },
    selectedConversionSource: {
      dialog: false,
      feedback: null,
      name: "",
      query: "",
      textColor: {
        hex: '#ffffff'
      },
      bgColor: {
        hex: "#333333"
      },
      textColorDialog: false,
      bgColorDialog: false,
    },
    rules: {
      counter: value => value.length <= 11 || 'Max 11 characters',
      senderID: value => {
        const pattern = /^[A-Za-z0-9]+$/
        return pattern.test(value) || 'Naam niet geldig.'
      },
    },
    activeCompDataOriginal: {},
    companies: [],
    branches: [],
    activeComp: "", 
    conversionStartDateRaw: "",
    conversionStartDialog: false,
    now: null,
    deleteSelectedSource: {
      dialog: false,
      index: null
    },
    selectedLanguage: "nl",
    smsSettingsFeedback: null,
  }),

  created() {
    this.loadUserComp();
    this.now = moment().format("YYYY-MM-DD");
  },

  methods: {

    loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      this.conversionStartDateRaw = null;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0]
          if(this.activeCompData.conversion.sources && this.activeCompData.conversion.sources.length > 0){
            this.activeCompData.conversion.sources.forEach(conversieItem =>{
              conversieItem.copy = false
            })
          }

        })
        .then(() => {
          this.loadBranches()
          this.loadBlacklisted()
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

    defaultConfirmEmail(){
      if(this.selectedLanguage == 'nl'){
        this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailSubject[this.selectedLanguage] = "Uw online afspraak bij " + this.activeCompData.name + " [Salon]"
        this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailContent[this.selectedLanguage] = "<p>Beste [Voornaam],</p><p>&nbsp;</p><p>Bedankt voor het maken van uw online afspraak bij " + this.activeCompData.name + " [Salon]. Uw afspraak is succesvol bevestigd.</p><p>&nbsp;</p><h3><strong>Uw afspraak is op [Afspraakdatum] om [Afspraaktijdstip] uur</strong></h3><p>&nbsp;</p><p>U kunt uw afspraak tot 24 uren van tevoren kosteloos telefonisch annuleren of wijzigen.</p><p>&nbsp;</p><p>Met vriendelijke groet,</p><p><br><strong>" + this.activeCompData.name + "</strong></p>" 
      }

      else if(this.selectedLanguage == 'en'){
        this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailSubject[this.selectedLanguage] = "Your online appointment at " + this.activeCompData.name + " [Salon]"
        this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailContent[this.selectedLanguage] = "<p>Dear [Voornaam],</p><p>&nbsp;</p><p>Thank you for making your online appointment at " + this.activeCompData.name + " [Salon]. Your appointment has been successfully confirmed.</p><p>&nbsp;</p><h3><strong>Your appointment is scheduled on [Afspraakdatum] at [Afspraaktijdstip]u</strong></h3><p>&nbsp;</p><p>You can cancel or change your appointment by telephone free of charge up to 24 hours in advance.</p><p>&nbsp;</p><p>Kind Regards,</p><p><br><strong>" + this.activeCompData.name + "</strong></p>" 
      }
        
    },

    defaultConfirmEmailNewClient(){
      if(this.selectedLanguage == 'nl'){
        this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailSubject[this.selectedLanguage] = "Uw online afspraak bij " + this.activeCompData.name + " [Salon]"
        this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailContent[this.selectedLanguage] = "<p>Beste [Voornaam],</p><p>&nbsp;</p><p>Bedankt voor het maken van uw online afspraak bij " + this.activeCompData.name + " [Salon]. Uw afspraak is succesvol bevestigd.</p><p>&nbsp;</p><h3><strong>Uw afspraak is op [Afspraakdatum] om [Afspraaktijdstip] uur</strong></h3><p>&nbsp;</p><p>U kunt uw afspraak tot 24 uren van tevoren kosteloos telefonisch annuleren of wijzigen.</p><p>&nbsp;</p><p>Met vriendelijke groet,</p><p><br><strong>" + this.activeCompData.name + "</strong></p>" 
      }

      else if(this.selectedLanguage == 'en'){
        this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailSubject[this.selectedLanguage] = "Your online appointment at " + this.activeCompData.name + " [Salon]"
        this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailContent[this.selectedLanguage] = "<p>Dear [Voornaam],</p><p>&nbsp;</p><p>Thank you for making your online appointment at " + this.activeCompData.name + " [Salon]. Your appointment has been successfully confirmed.</p><p>&nbsp;</p><h3><strong>Your appointment is scheduled on [Afspraakdatum] at [Afspraaktijdstip]u</strong></h3><p>&nbsp;</p><p>You can cancel or change your appointment by telephone free of charge up to 24 hours in advance.</p><p>&nbsp;</p><p>Kind Regards,</p><p><br><strong>" + this.activeCompData.name + "</strong></p>" 
      }
        
    },

    loadBranches(){
      db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.branches.push(branchCollection);
          });
        })
        .then(()=>{
          if(this.branches.length > 0){
            this.campagnUrl.branch = this.branches[0].branchNameSalonhub
          }
          
        })
        .catch(error=>{
          console.error("Error loading branches: ", error)
        })
    },

    addPhoneToBlacklist(){
      this.newBlacklist.phone = slugify(this.newBlacklist.phone, {
        replacement: "",
        remove: /[!@#$%^&*()"';:.,+-]/g,
        lower: true
      })
      
      db.collection("widgetBlacklist").add({
        phone: this.newBlacklist.phone,
        comment: this.newBlacklist.comment,
        compId: this.activeCompData.id,
        userId: `${this.userFirstName} ${this.userLastName}`, 
        created: new Date()
      })
      .then(()=>{
        this.blacklisted.push(this.newBlacklist)
        this.newBlacklist = {
          dialog: false,
          phone: null,
          comment: null
        };
      })
    },

    loadBlacklisted(){
      this.blacklisted = new Array()
      db.collection("widgetBlacklist")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let item = doc.data();
            item.id = doc.id;
            this.blacklisted.push(item);
          });
        })
        .catch(error=>{
          console.error("Error loading widgetBlacklist: ", error)
        })
    },

    UploadAdapter(loader){
      let token = Math.random().toString(36).substr(2);
      this.loader = loader
      
      let company = this.activeComp
      let imageUrl = ""
      loader.file.then(response => {
        this.upload = () => {
          return new Promise((resolve, reject) => {
            const file = response;
            const filename = response.name;

            const ext = filename.slice(filename.lastIndexOf("."));
            const fileUrl = "wysiwyg/" + filename + "-" + token + ext;

            let uploadTask = firebase
              .storage()
              .ref(fileUrl)
              .put(file);

            uploadTask.on(
              "state_changed",
              taskSnapshot => {
              },
              error => {
                console.error(error);
                reject();
              },
              () => {
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(url => {
                    imageUrl = url
                    resolve();
                  })
                  .catch(error => {
                    reject();
                  });
              }
            );
          }).then(()=>{
            return {
              default: imageUrl
            }
          })
        }
      })
    },

    addNewConversionSource(){
      this.newConversionSource.dialog = true;
    },

    editConversionSource(index){
      this.selectedConversionSource = { 
        feedback: null,
        name: this.activeCompData.conversion.sources[index].name,
        query: this.activeCompData.conversion.sources[index].query,
        textColor: this.activeCompData.conversion.sources[index].textColor,
        bgColor: this.activeCompData.conversion.sources[index].bgColor,
        textColorDialog: false,
        bgColorDialog: false,
        dialog: true,
        index: index
      }
    },

    deleteConversionSourceDialog(index){
      this.deleteSelectedSource.dialog = true
      this.deleteSelectedSource.index = index
    },

    addConversionSourceTag(){
      this.newConversionSource.feedback = null
      if(this.newConversionSource.name && this.newConversionSource.query){
        let newSource = {
          name: this.newConversionSource.name,
          query: this.newConversionSource.query,
          textColor: this.newConversionSource.textColor,
          bgColor: this.newConversionSource.bgColor,
          copy: false
        } 
        this.activeCompData.conversion.sources.push(newSource)
        db.collection("companies")
          .doc(this.activeComp)
          .set({
            conversion: {
              sources: this.activeCompData.conversion.sources
            } 
          }, { merge: true })
          .then(()=>{
            this.newConversionSource = {
              dialog: false,
              feedback: null,
              name: "",
              query: "",
              textColor: {
                hex: '#ffffff'
              },
              bgColor: {
                hex: "#333333"
              },
              textColorDialog: false,
              bgColorDialog: false,
            }
          })
      } else{
        this.newConversionSource.feedback = "Vul alle velden in om tag toe te voegen."
      }
    },

    updateConversionSourceTag(){
      this.selectedConversionSource.feedback = null
      
      if(this.selectedConversionSource.name && this.selectedConversionSource.query){
        let updatedSource = {
          name: this.selectedConversionSource.name,
          query: this.selectedConversionSource.query,
          textColor: this.selectedConversionSource.textColor,
          bgColor: this.selectedConversionSource.bgColor
        } 
        this.activeCompData.conversion.sources[this.selectedConversionSource.index] = updatedSource
        db.collection("companies")
          .doc(this.activeComp)
          .set({
            conversion: {
              sources: this.activeCompData.conversion.sources
            } 
          }, { merge: true })
          .then(()=>{
            this.activeCompData.conversion.sources.forEach(conversieItem =>{
              conversieItem.copy = false
            })
            this.selectedConversionSource = {
              dialog: false,
              feedback: null,
              name: "",
              query: "",
              textColor: {
                hex: '#ffffff'
              },
              bgColor: {
                hex: "#333333"
              },
              textColorDialog: false,
              bgColorDialog: false,
            }
          })
      } else{
        this.selectedConversionSource.feedback = "Vul alle velden in om wijzigingen op te slaan."
      }
    },

    deleteConversionSource(){
      
      this.activeCompData.conversion.sources.splice(this.deleteSelectedSource.index , 1)
      db.collection("companies")
        .doc(this.activeComp)
        .set({
          conversion: {
            sources: this.activeCompData.conversion.sources  
          } 
        }, { merge: true })
        .then(()=>{
          this.deleteSelectedSource.dialog = false
          this.deleteSelectedSource.index = null
        })
    },

    updateCallcenterSettings(){
      this.updateCallcenterBusy = true
      db.collection("companies")
        .doc(this.activeComp)
        .set({
          conversion: {
            callcenter: this.activeCompData.conversion.callcenter
          } 
        }, { merge: true })
        .then(()=>{
          this.activeCompDataOriginal.conversion.callcenter = _.cloneDeep(this.activeCompData.conversion.callcenter)
       })
       .then(()=>{
         this.updateCallcenterBusy = false
       })
    },

    updateCovenversionConfirmEmail(){
      db.collection("companies")
        .doc(this.activeComp)
        .set({
          conversion: {
            salonhubSettings: {
              confirmationEmail: {
                emailContent: this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailContent,
                emailSubject: this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailSubject
              }
            }
          } 
        }, { merge: true })
        .then(()=>{
          this.activeCompDataOriginal.conversion.salonhubSettings.confirmationEmail.emailContent = _.cloneDeep(this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailContent)
          this.activeCompDataOriginal.conversion.salonhubSettings.confirmationEmail.emailSubject = _.cloneDeep(this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailSubject)

       })
    },

    updateCovenversionConfirmEmailNewClient(){
      db.collection("companies")
        .doc(this.activeComp)
        .set({
          conversion: {
            salonhubSettings: {
              confirmationEmailNewClients: {
                emailContent: this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailContent,
                emailSubject: this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailSubject
              }
            }
          } 
        }, { merge: true })
        .then(()=>{
          this.activeCompDataOriginal.conversion.salonhubSettings.confirmationEmailNewClients.emailContent = _.cloneDeep(this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailContent)
          this.activeCompDataOriginal.conversion.salonhubSettings.confirmationEmailNewClients.emailSubject = _.cloneDeep(this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailSubject)

       })
    },

    updateSmsSettings(){
      this.updateSmsSettingsBusy = true;
      this.smsSettingsFeedback = null;

      if(this.activeCompData.conversion.smsSettings.senderID && this.activeCompData.conversion.smsSettings.senderID.length > 0 && /^[A-Za-z0-9]+$/.test(this.activeCompData.conversion.smsSettings.senderID)){
        if(this.activeCompData.conversion.smsSettings.callUsText.en && this.activeCompData.conversion.smsSettings.callUsText.nl){
          db.collection("companies")
            .doc(this.activeComp)
            .set({
              conversion: {
                smsSettings: this.activeCompData.conversion.smsSettings
              } 
            }, { merge: true })
            .then(()=>{
              this.activeCompDataOriginal.conversion.smsSettings = _.cloneDeep(this.activeCompData.conversion.smsSettings)
          })
          .then(()=>{
            this.updateSmsSettingsBusy = false;
          })
        }
        else{
          this.smsSettingsFeedback = "Vul alle velden in om op te slaan."
          this.updateSmsSettingsBusy = false;
        }
      }
      else{
        this.smsSettingsFeedback = "Vul alle velden in om op te slaan."
        this.updateSmsSettingsBusy = false;
      }
    },
    
    updateWidgetSettings(){
      this.updateWidgetSettingsBusy = true
      let startDate = null

      db.collection("companies")
        .doc(this.activeComp)
        .set({
          conversion: {
            start: this.conversionStartDate.firebase,
            adwordsBudget: this.activeCompData.conversion.adwordsBudget,
            showCallback: this.activeCompData.conversion.showCallback,
            feedBackOnClose: this.activeCompData.conversion.feedBackOnClose,
            termsUrl: this.activeCompData.conversion.termsUrl ? this.activeCompData.conversion.termsUrl : null,
            termsText: this.activeCompData.conversion.termsText ? this.activeCompData.conversion.termsText : null,
     
            salonhubSettings: {
              succesUrl: this.activeCompData.conversion.salonhubSettings.succesUrl,
              enableConfirmationEmail: this.activeCompData.conversion.salonhubSettings.enableConfirmationEmail,
              separateConfirmationEmailNewClient : this.activeCompData.conversion.salonhubSettings.separateConfirmationEmailNewClient,
            }
          } 
        }, { merge: true })
        .then(()=>{
          this.activeCompDataOriginal.conversion.salonhubSettings.enableConfirmationEmail = _.cloneDeep(this.activeCompData.conversion.salonhubSettings.enableConfirmationEmail)
          this.activeCompDataOriginal.conversion.salonhubSettings.separateConfirmationEmailNewClient = _.cloneDeep(this.activeCompData.conversion.salonhubSettings.separateConfirmationEmailNewClient)
          this.activeCompDataOriginal.conversion.salonhubSettings.succesUrl = _.cloneDeep(this.activeCompData.conversion.salonhubSettings.succesUrl)
          this.activeCompDataOriginal.conversion.adwordsBudget = _.cloneDeep(this.activeCompData.conversion.adwordsBudget)
          this.activeCompDataOriginal.conversion.showCallback = _.cloneDeep(this.activeCompData.conversion.showCallback)
          this.activeCompDataOriginal.conversion.feedBackOnClose = _.cloneDeep(this.activeCompData.conversion.feedBackOnClose)
          if(this.activeCompData.conversion.termsUrl){
            this.activeCompDataOriginal.conversion.termsUrl = _.cloneDeep(this.activeCompData.conversion.termsUrl)
          }
          if(this.activeCompData.conversion.termsText){
            this.activeCompDataOriginal.conversion.termsText = _.cloneDeep(this.activeCompData.conversion.termsText)
          }
          let selectedDate = _.cloneDeep(this.conversionStartDate.formatted)
          this.activeCompData.conversion.start = {};
          this.activeCompData.conversion.start.seconds = moment(selectedDate).format("X");
          this.conversionStartDateRaw = null;
        })
        .then(()=>{
          this.updateWidgetSettingsBusy = false;
        })
        .catch(error=>{
          console.error("Updaten niet gelukt: ", error)
        })
    },

    fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position="fixed";  //avoid scrolling to bottom
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }
      document.body.removeChild(textArea);
    },

    copyTextToClipboard(text, index, type) {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(()=> {
        this.campagnUrl.copy = false
        this.widgetUrl.copy = false
        this.activeCompData.conversion.sources.forEach(conversieItem =>{
          conversieItem.copy = false
        })
        this.generalTags.forEach(conversieItem =>{
          conversieItem.copy = false
        })
        if(type == 'source'){        
          this.activeCompData.conversion.sources[index].copy = true
          let newData = _.cloneDeep(this.activeCompData.conversion.sources)
          this.activeCompData.conversion.sources = newData

          setTimeout(()=>{ 
            this.activeCompData.conversion.sources[index].copy = false
          }, 1000);
        } 
        else if(type == 'tag'){
          this.generalTags[index].copy = true

          setTimeout(()=>{ 
            this.generalTags[index].copy = false
          }, 1000);
        }
        else if(type == 'campagne'){
          this.campagnUrl.copy = true

          setTimeout(()=>{ 
            this.campagnUrl.copy = false
          }, 1000);
        }
        else if(type == 'widget'){
          this.widgetUrl.copy = true

          setTimeout(()=>{ 
            this.widgetUrl.copy = false
          }, 1000);
        }

        
        
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    },

    copyVariableToClipboard(text, index){
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(()=> {
        this.emailVariables.forEach(variable =>{
          variable.copy = false
        })
        this.generalTags.forEach(conversieItem =>{
          conversieItem.copy = false
        })
        this.emailVariables[index].copy = true
        setTimeout(()=>{ 
          this.emailVariables[index].copy = false
        }, 1000);

      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  },

  computed: {
    conversionStartDate(){
      let date = {
        readable: "",
        formatted: "",
        firebase: null
      }
      if(this.conversionStartDateRaw){
        date.readable = moment(this.conversionStartDateRaw).locale('nl').format("D MMMM YYYY");
        date.formatted = moment(this.conversionStartDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(moment(this.conversionStartDateRaw).format("YYYY/MM/DD"));
        return date
      }
      else if(this.activeCompData.conversion.start){
        date.readable = moment.unix(this.activeCompData.conversion.start.seconds).locale('nl').format("D MMMM YYYY");
        date.formatted = moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY/MM/DD");
        date.firebase = new Date(moment(date.formatted).format("YYYY/MM/DD"));
        return date
      }
      else {
        return date
      }
    },

    conversionPackage(){
      let packageStatus = { 
        type: 'inactive',
        days: 0
      }

      if(this.activeCompData.packages && this.activeCompData.packages.length > 0 && _.indexOf(this.activeCompData.packages, 'conversion') >= 0){
        packageStatus.type = 'active';
      }
      else{
        // Package not purchased, check for active trial
        if(this.activeCompData.trials && this.activeCompData.trials.length > 0){
          this.activeCompData.trials.forEach(trailPackage =>{
            if(trailPackage.id == 'conversion'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                packageStatus.type = 'trial';
                packageStatus.days = moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days').diff(moment(), 'days')
              }
            }
          })
        }
      }
      return packageStatus
    },

    confirmChanged() {
      if (_.isEqual(this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailContent, this.activeCompDataOriginal.conversion.salonhubSettings.confirmationEmail.emailContent) == false ||
      _.isEqual(this.activeCompData.conversion.salonhubSettings.confirmationEmail.emailSubject, this.activeCompDataOriginal.conversion.salonhubSettings.confirmationEmail.emailSubject) == false) {
        return true;
      } else {
        return false;
      }
    },
    confirmNewClientChanged() {
      if (_.isEqual(this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailContent, this.activeCompDataOriginal.conversion.salonhubSettings.confirmationEmailNewClients.emailContent) == false ||
      _.isEqual(this.activeCompData.conversion.salonhubSettings.confirmationEmailNewClients.emailSubject, this.activeCompDataOriginal.conversion.salonhubSettings.confirmationEmailNewClients.emailSubject) == false) {
        return true;
      } else {
        return false;
      }
    },
    generatedWidgetUrl(){
      if(this.activeCompData.salonhubApiSettings.customer){
        return "?compId=" + this.activeCompData.salonhubApiSettings.customer + "&lang=" + this.widgetUrl.lang + "&info=" + this.widgetUrl.info
      } else{
        return ""
      }
    },

    websiteUrl(){
      let url = {
        enable: false,
        url: 'leeg'
      }
      let source = ""
      let openWidget = ""
      let name = ""
      let email = ""
      let phone = ""
      let treatment = ""
      let lang = ""
      let ci = ""
      let branch = ""
      let showPrices = ""
      let compUrl = this.activeCompData.url
      if(this.campagnUrl.source || this.campagnUrl.openWidget){
        url.enable = true
      } else {
        url.enable = false
      }

    
      if(this.campagnUrl.openWidget){
        openWidget = '#salonhubhogans/?companyId=' + this.activeCompData.id + '&sh=' + this.activeCompData.salonhubApiSettings.customer
      }

      if(this.campagnUrl.openWidget && this.campagnUrl.ci){
        ci = '&ci=' + this.campagnUrl.ci
      }

      if(this.campagnUrl.openWidget && this.campagnUrl.lang){
        lang = '&lang=' + this.campagnUrl.lang
      }

      if(this.campagnUrl.openWidget && this.campagnUrl.branch){
        branch = '&activeBranch=' + this.campagnUrl.branch
      }
      
      if(this.campagnUrl.openWidget && this.campagnUrl.name){
        name = '&shname=' + this.campagnUrl.name
      }

      if(this.campagnUrl.openWidget && this.campagnUrl.email){
        email = '&shem=' + this.campagnUrl.email
      }

      if(this.campagnUrl.openWidget && this.campagnUrl.phone){
        phone = '&shtel=' + this.campagnUrl.phone
      }

      if(this.campagnUrl.openWidget && this.campagnUrl.treatment){
        treatment = '&shtm=' + this.campagnUrl.treatment
      }   

      if(this.campagnUrl.openWidget && this.campagnUrl.showPrices == "no"){
        showPrices = '&shp=0'
      }

      if(this.campagnUrl.openWidget && this.campagnUrl.source){
        source = '&src=' + this.campagnUrl.source
      }

      if(!this.campagnUrl.openWidget && this.campagnUrl.source){
        source = '?src=' + this.campagnUrl.source
      }

      url.url = compUrl + openWidget + lang + ci + branch + name + email + phone + treatment + showPrices + source

      return url
    },
    allConversionItems(){
      let items = _.cloneDeep(this.generalTags)
   
      if(this.activeCompData.conversion.sources.length > 0){
         this.activeCompData.conversion.sources.forEach(source=>{
           items.push(source)
         })
      } 
      return items
    },
    
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },

    callChanged(){
      if(_.isEqual(this.activeCompData.conversion.callcenter, this.activeCompDataOriginal.conversion.callcenter)){
        return false
      } else {
        return true
      }
    },

    smsSettingsChanged(){
      if(_.isEqual(this.activeCompData.conversion.smsSettings, this.activeCompDataOriginal.conversion.smsSettings)){
        return false
      } else {
        return true
      }
    },

    changed() {
      let enableConfirmationEmail = _.isEqual(this.activeCompData.conversion.salonhubSettings.enableConfirmationEmail, this.activeCompDataOriginal.conversion.salonhubSettings.enableConfirmationEmail)
      let separateConfirmationEmailNewClient = _.isEqual(this.activeCompData.conversion.salonhubSettings.separateConfirmationEmailNewClient, this.activeCompDataOriginal.conversion.salonhubSettings.separateConfirmationEmailNewClient)
      let succesUrl = _.isEqual(this.activeCompData.conversion.salonhubSettings.succesUrl, this.activeCompDataOriginal.conversion.salonhubSettings.succesUrl)
      let adwordsBudget = _.isEqual(this.activeCompData.conversion.adwordsBudget, this.activeCompDataOriginal.conversion.adwordsBudget)
      let showCallback = _.isEqual(this.activeCompData.conversion.showCallback, this.activeCompDataOriginal.conversion.showCallback)
      let feedBackOnClose = _.isEqual(this.activeCompData.conversion.feedBackOnClose, this.activeCompDataOriginal.conversion.feedBackOnClose)
      let termsUrl = _.isEqual(this.activeCompData.conversion.termsUrl, this.activeCompDataOriginal.conversion.termsUrl)
      let termsText = _.isEqual(this.activeCompData.conversion.termsText, this.activeCompDataOriginal.conversion.termsText)

      if(this.activeCompData.conversion.start && this.activeCompData.conversion.start.seconds){
        if (moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY/MM/DD") != this.conversionStartDate.formatted || !termsUrl || !termsText || !adwordsBudget || !feedBackOnClose || !enableConfirmationEmail || !separateConfirmationEmailNewClient || !succesUrl || !showCallback) {
          return true;
        } else {
          return false;
        }
      } else{
        if (this.conversionStartDate || enableConfirmationEmail || separateConfirmationEmailNewClient || succesUrl) {
          return true;
        } else {
          return false;
        }
      }
      
    }
  }
};
</script>

<style>
  .email-preview .ck.ck-editor__main .ck.ck-content.ck-editor__editable{
    background-color: var(--v-menu-base)!important;
    border-color: var(--v-menuborder-base)!important;
  }
</style>

<style scoped>
  .conversion-source-tags{
    margin: 15px 0;
    padding: 10px 5px;
    background-color: var(--v-menuhover-base)
  }
  .conversion-source-tags:after{
    clear: both;
    display: block;
    content: "";
  }

  .tag-query{
    font-style: italic;
    font-size: 12px;
    margin: 0 0 0 5px;
  }

  .copy-tag-url{
    display: block;
    cursor: pointer!important;
    pointer-events: auto;
    text-align: center;
    color: #333;
    font-size: 12px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
  }

  .copy-tag-url .v-icon{
    font-size: 12px!important;
  }

  .copy-tag-url.copied{
    font-style: italic;
    color: #000;
  }

  .copy-tag-url:hover{
    cursor: pointer!important;
    color: #000;
  }

  
</style>
